/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ApplyDirectoryRoleSetupForm,
  ApplyDirectoryRoleSetupForm$Outbound,
  ApplyDirectoryRoleSetupForm$outboundSchema,
} from "../components/applydirectoryrolesetupform.js";

export type ApplyDirectoryRoleSetupSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ApplyDirectoryRoleSetupRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  applyDirectoryRoleSetupForm: ApplyDirectoryRoleSetupForm;
};

/** @internal */
export type ApplyDirectoryRoleSetupSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ApplyDirectoryRoleSetupSecurity$outboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupSecurity$Outbound,
  ApplyDirectoryRoleSetupSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function applyDirectoryRoleSetupSecurityToJSON(
  applyDirectoryRoleSetupSecurity: ApplyDirectoryRoleSetupSecurity,
): string {
  return JSON.stringify(
    ApplyDirectoryRoleSetupSecurity$outboundSchema.parse(
      applyDirectoryRoleSetupSecurity,
    ),
  );
}

/** @internal */
export type ApplyDirectoryRoleSetupRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  ApplyDirectoryRoleSetupForm: ApplyDirectoryRoleSetupForm$Outbound;
};

/** @internal */
export const ApplyDirectoryRoleSetupRequest$outboundSchema: z.ZodMiniType<
  ApplyDirectoryRoleSetupRequest$Outbound,
  ApplyDirectoryRoleSetupRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    applyDirectoryRoleSetupForm: ApplyDirectoryRoleSetupForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      applyDirectoryRoleSetupForm: "ApplyDirectoryRoleSetupForm",
    });
  }),
);

export function applyDirectoryRoleSetupRequestToJSON(
  applyDirectoryRoleSetupRequest: ApplyDirectoryRoleSetupRequest,
): string {
  return JSON.stringify(
    ApplyDirectoryRoleSetupRequest$outboundSchema.parse(
      applyDirectoryRoleSetupRequest,
    ),
  );
}
